import { Divider } from "@mui/material";
import { Fragment } from "react";
import { Status, StepDetails } from "types/stepper";
import { Step } from "./Step";
import { useStyles } from "./styles";

interface Props<T> {
  steps: StepDetails<T>[];
  dataTestId?: string;
  setSteps: (steps: StepDetails<T>[], isPrevStepClicked: boolean) => void;
}

export function Stepper<T>({ steps, setSteps }: Props<T>) {
  const classes = useStyles({});

  const { ACTIVE, VISITED } = Status;

  const setStepStatus = (stepId: T) => {
    const clickedStepIndex = steps.findIndex((step) => step.id === stepId);
    const activeStepIndex = steps.findIndex((step) => step.status === ACTIVE);
    const isPreviousStepClicked = clickedStepIndex < activeStepIndex;

    setSteps(
      steps.map((step) => {
        if (step.id === stepId) {
          return {
            ...step,
            status: ACTIVE,
          };
        }
        return {
          ...step,
          status: step.status === ACTIVE ? VISITED : step.status,
        };
      }),
      isPreviousStepClicked,
    );
  };

  return (
    <div className={classes.stepsWrapper}>
      {steps.map((step, index) => (
        <Fragment key={index}>
          <Step
            details={step}
            onClick={() => {
              if (
                steps.find((step) => step.status === ACTIVE)?.id === step.id
              ) {
                return;
              }

              setStepStatus(step.id);
            }}
            index={index + 1}
            key={`${step.id}${index}`}
          />
          {index < steps.length - 1 && <Divider className={classes.divider} />}
        </Fragment>
      ))}
    </div>
  );
}
